export default __webpack_public_path__ + "static/media/personal3.466ccb89.jpeg";